const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 7C7.75 4.65279 9.65279 2.75 12 2.75C14.3472 2.75 16.25 4.65279 16.25 7C16.25 9.34721 14.3472 11.25 12 11.25C9.65279 11.25 7.75 9.34721 7.75 7ZM15.873 11.25C17.0263 10.1984 17.75 8.68372 17.75 7C17.75 3.82436 15.1756 1.25 12 1.25C8.82436 1.25 6.25 3.82436 6.25 7C6.25 8.68372 6.97368 10.1984 8.12696 11.25H8C5.37579 11.25 3.25 13.3758 3.25 16V18.2289L3.39882 18.4284C5.35387 21.0495 8.47256 22.75 12 22.75C15.5274 22.75 18.6461 21.0495 20.6012 18.4284L20.75 18.2289V16C20.75 13.3758 18.6242 11.25 16 11.25H15.873ZM12 12.75H8C6.20421 12.75 4.75 14.2042 4.75 16V17.7257C6.44166 19.8738 9.05522 21.25 12 21.25C14.9448 21.25 17.5583 19.8738 19.25 17.7257V16C19.25 14.2042 17.7958 12.75 16 12.75H12Z",
    fill: props.color
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.2b52c015c02e9079703e094b13487f9c.svg";
export { ForwardRef as ReactComponent };